<template>
  <div>
    <el-dialog 
      title="Profile " :close-on-press-escape="false" width="60%"
      :visible.sync="outerVisible"
      :before-close="handleClose">


      <el-row>

        <el-col :span="8">
          <profile-avatar/>
        </el-col>
        <el-col :span="16">

          <el-tabs type="border-card" v-model="selectedTab">


            <el-tab-pane name="first">
              <span slot="label" class="tab-element"> Details</span>
              <profile-details @closeDialog="outerVisible = false"/>

            </el-tab-pane>
            <el-tab-pane name="second">
              <span slot="label" class="tab-element"> Security</span>
              <profile-security @closeDialog="outerVisible = false"/>

            </el-tab-pane>
            <el-tab-pane name="third">
              <span slot="label" class="tab-element"> SMTP</span>
              <smtp @closeDialog="outerVisible = false"/>
            </el-tab-pane>
            <!--<el-tab-pane name="forth">-->
            <!--<span slot="label" class="tab-element">Gateways Configuration</span>-->
            <!--<configuration @closeDialog="outerVisible = false"/>-->
            <!--</el-tab-pane>-->
          </el-tabs>

        </el-col>

      </el-row>


    </el-dialog>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import smtp from "./smtp/smtp";
  import configuration from "./configuration/configuration";
  import ProfileDetails from "./ProfileDetails";
  import ProfileSecurity from "./ProfileSecurity";
  import ProfileAvatar from "./ProfileAvatar";

  export default {
    name: "Profile",
    components: {
      smtp,
      ProfileDetails,
      ProfileSecurity,
      ProfileAvatar,
      configuration
    },
    data() {
      return {
        selectedTab: "first",

        profile: {},
        password: "",
        email: "",
        OldPassword: "",
        dialogVisibleNewWidget: false,
        outerVisible: false
      };
    },
    methods: {
      show() {
        this.outerVisible = true;
      },
      handleClose(done) {
        console.log(done);
        this.$confirm("Are you sure to close this dialog?");
        this.$confirm("Are you sure you want to close this dialog?", "", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        })
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
      }
    },
    computed: {
      ...mapGetters(["currentUser"])
    }
  };
</script>

<style lang="scss" scoped>
  .div1 {
    padding-left: 40%;
    padding-right: -40em;
  }

  .tab-element {
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/Profile.vue